const MARKER_REGEX =
	/<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;

/**
 * Function to replace all open loadable input tags with self closing tags.
 *
 * innerHTML method automatically removes self closing input tags (<input />) and returns <input>, but this breaks the SSR loadable replacement regex,
 * which relies on either <input></input> or <input /> loadable tags.
 *
 * Regex only matches <input>, and excludes:
 *
 * <input />
 * <input></input>
 *
 * as these are handled by the original loadable regex replacement.
 *
 * */
export function sanitizeInputLoadablesForSSR(html: string): string {
	return html.replace(MARKER_REGEX, (inputTag) => {
		return `${inputTag.slice(0, -1)} />`;
	});
}
